import { useState } from 'react';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Stack } from '@/common/components/Stack/Stack';

export interface ICharCounterProps {
  value: number;
  maxLength: number;
}

export const CharCounter = ({ value, maxLength }: ICharCounterProps) => {
  const [width, setWidth] = useState<number>();

  return (
    <Stack horizontal>
      <BodyText
        className={styles.value}
        style={{ width }}
        size="sm"
        color="neutral20"
      >
        {value}
      </BodyText>
      <BodyText size="sm" color="neutral20">
        /
      </BodyText>
      <BodyText
        size="sm"
        color="neutral20"
        onLayout={(evt) => {
          setWidth(evt.nativeEvent.layout.width);
        }}
      >
        {maxLength}
      </BodyText>
    </Stack>
  );
};

const styles = {
  value: 'inline-block text-right whitespace-nowrap',
};
